import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "アプリのリニューアルのご支援をさせていただきました。このプロジェクトは、コンセプトの再定義、ユーザーメリットと効果を鑑みた機能の取捨選択のワークショップなどを実施しました。弊社は、トーン＆マナーを考慮したUIデザイン、アプリ開発、継続的なシステム改修・運用を支援しています。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const peachjohnPageMeta: PageMeta = {
  title: "PEACH JOHN 公式アプリ | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "UIUX モバイルアプリ システム化 DX推進 フロントエンド開発",
  image: primaryImage,
  url: `${SITE_URL}/cases/peachjohn/`,
}

export const peachjohnSchema = buildCaseStudySchema({
  slug: "peachjohn",
  pageTitle: peachjohnPageMeta.title,
  description: peachjohnPageMeta.description,
  headline: "PEACH JOHN 公式アプリ",
  alternativeHeadline: "株式会社ピーチ・ジョン",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/peachjohn.webp"],
  clientName: "株式会社ピーチ・ジョン",
  breadcrumbLabel: "PEACH JOHN 公式アプリ",
})
